import { Label } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledLabelError = styled(Label)`
border: 1px solid #e0b4b4 !important;
color: #9f3a38 !important;
position: absolute !important;
margin-top: 0.5em !important;
background: #fff!important;
max-width: 300px;
z-index: 99;
`